import handleClick from '../../../../../../utils/handleClick';
import computeClassName from '../../../../../../utils/computeClassName';
import CCIconClose16x16 from '../../../Icon/Close/16x16';

const constants = Object.freeze({
  COMPONENT_NAME: 'CCAnnouncementToastDismissControl',
  CLASSNAME_BASE: 'appearance-none inline-flex flex-row items-center cursor-pointer text-cc-accent-contrast'
});

export const propsDefaults = Object.freeze({
  title: 'Dismiss toast',
  fn: null,
  fnArgs: undefined,
  className: ''
});

function getComputedClassName(propsClassName) {
  return computeClassName(propsClassName, constants.CLASSNAME_BASE);
}

export default function CCAnnouncementToastDismissControl(
  {
    title = propsDefaults.title,
    fn = propsDefaults.fn,
    fnArgs = propsDefaults.fnArgs,
    className = propsDefaults.className
  }
) {
  const computedClassName = getComputedClassName(className);
  return (
    <button type="button"
            className={computedClassName}
            aria-label={title}
            title={title}
            onClick={handleClick(fn, fnArgs)}>
      <span className="sr-only">{title}</span>
      <span aria-hidden="true"><CCIconClose16x16/></span>
    </button>
  );

}
